enum ContractInsuranceType {
  NONE = 0, // 무보험
  COLLISION_DAMAGE_WAIVER = 1, // 자차 보험
  LIABILITY_PROTECTION = 2, // 대인/대물 보험
  THEFT_PROTECTION = 3, // 도난 보험
  PERSONAL_ACCIDENT_INSURANCE = 4, // 상해 보험
  PERSONAL_EFFECTS_COVERAGE = 5, // 분실 보험
}

export const allCases = [ContractInsuranceType.COLLISION_DAMAGE_WAIVER, ContractInsuranceType.NONE];

export const name = (type: ContractInsuranceType) => {
  switch (type) {
    case ContractInsuranceType.NONE:
      return '무보험';
    case ContractInsuranceType.COLLISION_DAMAGE_WAIVER:
      return '자차보험';
    case ContractInsuranceType.LIABILITY_PROTECTION:
      return '대인/대물보험';
    case ContractInsuranceType.THEFT_PROTECTION:
      return '도난보험';
    case ContractInsuranceType.PERSONAL_ACCIDENT_INSURANCE:
      return '상해보험';
    case ContractInsuranceType.PERSONAL_EFFECTS_COVERAGE:
      return '분실보험';
    default:
      return '';
  }
};

export const exist = (type: ContractInsuranceType) => {
  switch (type) {
    case ContractInsuranceType.NONE:
      return '미가입';
    default:
      return '가입';
  }
};

export default ContractInsuranceType;
